export default "__VITE_ASSET__da50f03b__"